import { Injectable } from "@angular/core";
import { Fee, OrderResponse } from "./types/order.type";

@Injectable({
  providedIn: 'root'
})
export class CalculationsService {

  getOrderDeliveryFee(odooOrder: any, subTotal: number, products: any): number {
    // TODO If the client doesnt have a order created, with this logic , it will show FREE, and after the SUBMIT ORDER, then we have the specific amount.
    if (!odooOrder?.paymentDetails)
      return 0

    if (!products?.common?.length && !products?.subscription?.length) return 0;

    let fee = 0;
    let orderDeliveryFeeData = odooOrder?.paymentDetails?.deliveryFee || null;
    if (odooOrder.paymentDetails.useDeliveryFeeRange) {
      const deliveryFee = orderDeliveryFeeData || [];
      if (deliveryFee.length) {
        for (const element of deliveryFee) {
          if (subTotal >= element.minSpend && subTotal <= element.maxSpend) {
            fee = element.amount;
            break;
          }
        }
      }
    } else {
      if (orderDeliveryFeeData.enableFreeDeliveryThreshold) {
        fee = subTotal >= orderDeliveryFeeData.minSpend ? 0 : orderDeliveryFeeData.amount
      } else {
        fee = orderDeliveryFeeData.amount
      }
    }

    return fee;

  }

  getOrderTotal(odooOrder: any, products: any): number {
    const showTotal = this.validateProductsExistence(products);
    if (!showTotal) return 0;
    return odooOrder?.paymentDetails?.total || 0;
  }

  setUpOrderProducts(odooOrder: any): any {
    const {
      common: odooCommonProducts = [],
      subscription: odooSubscriptionProducts = []
    } = odooOrder?.products || {};

    return {
      common: odooCommonProducts,
      subscription: odooSubscriptionProducts,
    }
  }

  getTipAmount(odooOrder: any, products: any) {
    const odooTipAmount = odooOrder?.paymentDetails?.tip?.amount || 0;
    const showTipOrDonation = this.validateProductsExistence(products);
    if (!showTipOrDonation)
      return 0;
    return odooTipAmount || 0
  }

  getDonationVoluntaryAmount(odooOrder: any, products: any) {
    const odooDonationAmount = odooOrder?.paymentDetails?.donation?.amount || 0;
    const showTipOrDonation = this.validateProductsExistence(products);
    if (!showTipOrDonation)
      return 0;
    return odooDonationAmount || 0;
  }

  validateProductsExistence(products: any) {
    return products?.subscription?.length || products?.common?.length
  }

  getOrderCoupons(coupons: any[]) {
    try {
      if (!coupons.length) return 0;
      return coupons.reduce((prev: number, current: any) => prev + current.amount, 0);
    } catch (error) {
      console.log('ERROR WITH COUPONS CALCULATION')
      return 0
    }
  }

  calculateOrderAdditionalFees(odooOrder: OrderResponse | null, subtotal: number): Fee[] {
    const fees = odooOrder?.paymentDetails.fees || [];
    fees.forEach(element => element.total = element.percentage ? +(subtotal * (element.percentage / 100)).toFixed(2) : +((element.value || 0).toFixed(2)));
    return fees;
  }

  getOrderTotalSavings(data: { subtotal: number, grossSubtotal: number }) {
    const { subtotal, grossSubtotal } = data;
    const saving = grossSubtotal - subtotal;
    return saving > 0 ? saving : 0;
  }

}
